module.exports = __webpack_public_path__ + "img/qi-faculdade-e-escola-tecnica-negativa.84ed5789.svg";